import { render, staticRenderFns } from "./FPAddPaymentLayout.vue?vue&type=template&id=7bcf0a18"
import script from "./FPAddPaymentLayout.vue?vue&type=script&lang=js"
export * from "./FPAddPaymentLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports